import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';

import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Memo, EAA_ErrorText, EAA_Input } from '~/components/EditAndAddItem';
import PickSqCheckBox from '~/components/CheckBox/PickSqCheckBox';

import RegularSchedule from './RegularSchedule';
import ExtraSchedule from './ExtraSchedule';

const styles = (theme) => ({
    root: {
    },
});

const backConductList = [
    { name: '進行補給', value: '進行補給' },
    { name: '進行換員', value: '進行換員' },
    { name: '進行設備維修', value: '進行設備維修' },
    { name: '進行部件裝載', value: '進行部件裝載' },
];

const ShipSchedule = (props) => {
    const { classes, shipId, shipName, titleWidth, disabled, returnInputValue, checkChange, changeData, data, z, errorBody = {}, errorLeft } = props;

    useEffect(() => {
        if (data) {
            // console.log(z, 'ShipSchedule', data);
        }
    }, [data]);

    
    return (
        <>
            <RegularSchedule {...props} d='today' title='今日進度' />
            <Divider />
            <RegularSchedule {...props} d='recently' title='近日進度' />
            <Divider />
            <ExtraSchedule {...props} />
        </>
    );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(ShipSchedule);
